import ModalComponent from 'components/common/ModalComponent';
import PropTypes from 'prop-types';

const labelClass = 'block text-sm font-medium text-gray-700 mb-2';
const inputClass =
  'w-full p-2 border rounded-md shadow-sm focus:ring-2 focus:ring-greenPrimary focus:border-transparent';

const CropModal = ({ isOpen, onClose, onSave, crop }) => {
  if (!isOpen) return null;

  const isEdit = !!crop;

  const handleSave = formData => {
    if (!formData.name || formData.name.trim() === '') {
      return;
    }
    onSave({ name: formData.name.trim() });
  };

  return (
    <ModalComponent
      title={isEdit ? 'Edit Crop' : 'New Crop'}
      isOpen={isOpen}
      onClose={onClose}
      initialData={crop || { name: '' }}
      onSave={handleSave}
    >
      {({ formData, handleChange }) => (
        <form autoComplete="off">
          <div>
            <label className={labelClass}>Crop Name *</label>
            <input
              type="text"
              name="name"
              value={formData.name || ''}
              onChange={handleChange}
              className={inputClass}
              placeholder="e.g., Tomato, Pepper, Cucumber"
              required
            />
          </div>
        </form>
      )}
    </ModalComponent>
  );
};

CropModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onSave: PropTypes.func,
  crop: PropTypes.object
};

export default CropModal;
